import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { MenuComponent } from '../../layout/menu/menu.component';
import { RodapeComponent } from '../../layout/rodape/rodape.component';

@Component({
  selector: 'app-sobre',
  standalone: true,
  imports: [CommonModule, MenuComponent, RodapeComponent],
  templateUrl: './sobre.component.html',
  styleUrl: './sobre.component.css'
})
export class SobreComponent implements OnInit {
  constructor(private title: Title, private meta: Meta) {}

  ngOnInit() {
    this.title.setTitle('Sobre Nós - Fluxodigital - Web | Infra');
    this.meta.updateTag({ 
      name: 'description', 
      content: 'Conheça a Fluxodigital, especialistas em Desenvolvimento, Operações e Infraestruturas de TI.' 
    });

    // Open Graph
    this.meta.updateTag({ property: 'og:title', content: 'Sobre Nós - Fluxodigital - Web | Infra' });
    this.meta.updateTag({ property: 'og:description', content: 'Comprometidos com a excelência tecnológica desde 2017.' });
  }
}
